import { useMemo } from 'react';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';

const useGoodOptionItem = ({ leafItem, label, priceFormat }) => {
  const priceUtils = new PriceUtils();

  const disabled = useMemo(() => {
    if (!leafItem) {
      return false;
    }
    const { stopSale, soldOut } = leafItem;
    return soldOut || stopSale;
  }, [leafItem]);

  const labelWithSalePossibleQuantity = useMemo(() => {
    if (!leafItem) {
      return label;
    }

    const {
      additionalItem,
      additionalItemStockManagement,
      stockManagement,
      stockQtyDisplay,
      salePossibleQuantity,
      stopSale,
      soldOut,
    } = leafItem;

    if (stopSale) {
      return `[판매중지] ${label}`;
    }
    if (soldOut) {
      return `[품절] ${label}`;
    }

    const management = (!additionalItem && stockManagement) || (additionalItem && additionalItemStockManagement);
    if (!stockQtyDisplay || !management) {
      return label;
    }
    return `${label} (재고 : ${salePossibleQuantity})`;
  }, [label, leafItem]);

  const discountPrice = useMemo(() => {
    const internalDiscountPrice = priceUtils.getDisplayPrice({
      priceFormat,
      price: NumberFormat(leafItem?.discountPrice),
      formattedPrice: NumberFormat(leafItem?.discountFormattedPrice),
    });

    return leafItem ? `${internalDiscountPrice}${priceFormat}` : '';
  }, [leafItem, priceFormat]);

  return { disabled, labelWithSalePossibleQuantity, discountPrice };
};

export default useGoodOptionItem;
